module.exports = {
  EDIT_TRANSLATIONS_FAILURE: 'EDIT_TRANSLATIONS_FAILURE',
  EDIT_TRANSLATIONS_REQUEST: 'EDIT_TRANSLATIONS_REQUEST',
  EDIT_TRANSLATIONS_SUCCESS: 'EDIT_TRANSLATIONS_SUCCESS',
  CLEAR_PRESERVED_IMPC: 'CLEAR_PRESERVED_IMPC',
};
